import { Button, Paper, Stack, Typography } from '@mui/material';

export default function AccionesDia({ onCompra, onVenta, onSalida, onGasto, onLimpieza, onAjuste, onTraspaso, onFondos, díaBloqueado }) {
  return (
    <Paper sx={{ p: 3, mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        📋 Opciones del Día
      </Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
        <Button variant="contained" color="success" onClick={onCompra} disabled={díaBloqueado}>
          📦 Compra
        </Button>
        <Button variant="contained" color="primary" onClick={onVenta} disabled={díaBloqueado}>
          🛍️ Venta
        </Button>
        <Button variant="contained" color="info" onClick={onSalida} disabled={díaBloqueado}>
          📤 Salida
        </Button>
        <Button variant="contained" color="warning" onClick={onGasto} disabled={díaBloqueado}>
          💸 Gasto
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#5D4037', color: '#fff' }}
          onClick={onLimpieza}
          disabled={díaBloqueado}
        >
          🧹 Limpieza
        </Button>
        <Button variant="contained" color="secondary" onClick={onAjuste} disabled={díaBloqueado}>
          ⚙️ Ajuste
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#C62828', color: '#fff' }}
          onClick={onTraspaso}
          disabled={díaBloqueado}
        >
          🔄 Traspaso
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: '#0097A7', color: '#fff' }}
          onClick={onFondos}
          disabled={díaBloqueado}
        >
          💳 Fondos Externos
        </Button>
      </Stack>
    </Paper>
  );
}
